import { Injectable } from "@angular/core";
import { CubiqWorker } from "../../worker/CubiqWorker";
import { ISystemMessageService, SYSTEM_MESSAGE_TYPE } from "../ISystemMessageService";
import { Observable, ReplaySubject, Subscription } from "rxjs";
import {
  PRIMITIVE,
  ServiceMessageBrokerFactory,
  ServiceMessageBroker,
} from "shared/provider-webworker";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { CubiqSerializer } from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

@Injectable()
export class SystemMessagePrimaryService implements ISystemMessageService {
  private broker: ServiceMessageBroker;
  private ports: Array<MessagePort> = new Array<MessagePort>();
  private lastSystemMessage: CubiqTS.SystemMessageImpl | null = null;
  private _systemMessageSubject: ReplaySubject<CubiqTS.SystemMessageImpl> =
    new ReplaySubject<CubiqTS.SystemMessageImpl>(1);

  private workerConnectionSubscription: Subscription;

  constructor(
    private worker: CubiqWorker,
    private factory: ServiceMessageBrokerFactory,
    private serializer: CubiqSerializer,
  ) {
    this.initialize();
  }

  private initialize(): void {
    const ENCODABLE_TYPE = new CubiqTS.SystemMessageImpl();

    this.broker = this.factory.createMessageBroker(SYSTEM_MESSAGE_TYPE, true, true);
    this.broker.registerMethod("initPort", [PRIMITIVE], this.initPort.bind(this), null, false);

    this.workerConnectionSubscription = this.worker
      .getEncodableObservable(CubiqTS.SystemMessageImpl.name)
      .subscribe((event: CubiqTS.SystemMessageImpl) => {
        this.lastSystemMessage = event;
        this._systemMessageSubject.next(event);

        // let message = this.serializer.serialize(event, ENCODABLE_TYPE);
        //this.sendMessageToAll(message);
      });
  }

  public getSystemMessages(): Observable<CubiqTS.SystemMessage> {
    return this._systemMessageSubject.asObservable();
  }

  public initPort(port: MessagePort): void {
    this.ports.push(port);

    if (this.lastSystemMessage) {
      let lastMessage = this.serializer.serialize(
        this.lastSystemMessage,
        CubiqTS.SystemMessageImpl,
      );
      port.postMessage(this.lastSystemMessage);
    }
  }

  private sendMessageToAll(message: ArrayBuffer): void {
    this.ports.forEach((port) => {
      port.postMessage(message);
    });
  }
}
